import React, {useEffect, useState, useContext} from 'react';
import styled from "styled-components";
import {useHistory} from "react-router";

import {StyledTable, TableHeader} from "../Components/Commons/TBTable.react";
import TransactionRow from "../Components/Transactions/TransactionRow.react";
import useFetch from "../Utilities/API/useFetch.react";
import AppContext from "../Context/AppContext.react";
import TBSearch from "../Components/Commons/Search.react";
import ExportTransactionsButton from "../Components/Transactions/ExportTransactions.react";
import {Button, Icon} from "react-materialize";
import {StyledForeground} from "../Components/Commons/StyledForeground.react";
import Pagination from "../Components/Commons/Pagination.react";
import Filter from "../Components/Transactions/Filters/Filter.react";


const PageWrapper = styled.div`
  padding: 6rem 4rem 0rem 4rem;
  height: 100%;
  color: white;
  
  .header {
    display: flex;
    justify-content: space-between;
    padding-bottom: 3rem;
    h1 {
      color: white;
      font-size: 3rem;
      font-weight: 400;
      letter-spacing: 1px;
      margin: 0;
    }
   }
  
  .subheader {
    display: flex;
    justify-content: space-between;
    
    h2 {
      font-size: 2.5rem;
    }
  }
  
  .content {
   
  }
`

const StyledFilters = styled.div`
  display: flex;
  justify-content: space-between;
  padding-bottom: 0.6rem;
  
  .filter-button {
     color: white;
     background-color: transparent;
     border: 1px solid white;
  }
`

export const MARGIN_TRANSACTION = {
  enterprise: true,
  datetime: "2020-01-29T21:43:00.000Z",
  external_id: "",
  fee_asset_code: "USD",
  fee_quantity: "",
  id: "a620faa9-11fb-4a57-9c7a-0ae6d122d3ce",
  in_asset_code: "BTC",
  in_quantity: "65",
  integration: "DemoExchange",
  out_asset_code: "USD",
  out_quantity: "2404247.92858485",
  price_asset_code: "USD",
  price_quantity: "43.635031581549214",
  type: "MARGIN",
  user_id: null,
  source: '12080 - Fireblocks',
  entries: [{
    account: 'Cash',
    assetQuantity: {
      asset: "USD",
      quantity: 10340
    },
    lineType: "debit",
    price: {
      asset: "USD",
      quantity: 10340
    }
  },
  {
    account: 'BTC Asset Exchanged Owned',
    assetQuantity: {
      asset: "BTC",
      quantity: 1
    },
    lineType: "debit",
    price: {
      asset: "USD",
      quantity: 9000
    }
  }]
}

export const LOAN_TRANSACTION = {
  enterprise: true,
  datetime: "2018-01-06T21:43:00.000Z",
  external_id: "",
  fee_asset_code: "BTC",
  fee_quantity: "0.000368",
  id: "0ebc9ded-6c14-49a6-b158-cc1a01134214",
  in_asset_code: "USD",
  in_quantity: "10,150",
  integration: "DemoExchange",
  out_asset_code: "BTC",
  out_quantity: "982",
  price_asset_code: "USD",
  price_quantity: "9,000",
  type: "LOAN",
  user_id: null,
  source: '12080 - Fireblocks',
  entries: [
    {
      account: 'Cash',
      assetQuantity: {
        asset: "USD",
        quantity: 10340
      },
      lineType: "debit",
      price: {
        asset: "USD",
        quantity: 10340
      }
    },
    {
      account: 'BTC Asset Exchanged Owned',
      assetQuantity: {
        asset: "BTC",
        quantity: 1
      },
      lineType: "debit",
      price: {
        asset: "USD",
        quantity: 9000
      }
    }
  ]
}
export const findJournalEntry = (id) => {
    console.log(id)
    return journalEntries2.find(x => x.id === id)
}

let journalEntries2 = [
  {
    "id": 'a620faa9-11fb-4a57-9c7a-0ae6d122d3ce',
    "user_id": 'c48a6355-0f54-456b-97b3-ad66456c0cfa',
    "datetime": "1/29/2021 0:00:00",
    "source": "Torch",
    "type": "MARGIN - INITIAL",
    "enterprise": true,
    "metadata": {
        "type": "Margin",
        "subtype": "Initial"
    },
    "lines": [
        {
            "account": "12080 - Fireblocks",
            "journalAssetQuantity": {
                "asset": "USD",
                "quantity": 2404247.929
            },
            "lineType": "debit",
            "inventoryAssetQuantity": {
                "asset": "BTC",
                "quantity": 65.00000000
            }
        },
        {
            "account": "23500 - Collateral Due to Counterparty",
            "journalAssetQuantity": {
                "asset": "USD",
                "quantity": 2404247.929
            },
            "lineType": "credit",
            "inventoryAssetQuantity": null
        }
    ]
},
{
    "id": '03b02163-e7a9-4a83-ae7d-c02ee5f46a7a',
    "user_id": 'c48a6355-0f54-456b-97b3-ad66456c0cfa',
    "datetime": "1/13/21 0:00",
    "source": "Torch",
    "type": "MARGIN - CALL",
    "enterprise": true,
    "metadata": {
        "type": "Margin",
        "subtype": "Call"
    },
    "lines": [
        {
            "account": "12080 - Fireblocks",
            "journalAssetQuantity": {
                "asset": "USD",
                "quantity": 32928.50387
            },
            "lineType": "debit",
            "inventoryAssetQuantity": {
                "asset": "BTC",
                "quantity": 0.97000000
            }
        },
        {
            "account": "23500 - Collateral Due to Counterparty",
            "journalAssetQuantity": {
                "asset": "USD",
                "quantity": 32928.50387
            },
            "lineType": "credit",
            "inventoryAssetQuantity": null
        }
    ]
},
{
    "id": '0f6fc3bd-029a-4dab-a987-63efcca8495d',
    "user_id": 'b877f0ec-c056-43e3-9b9f-b22e9bcdbaff',
    "datetime": "1/7/21 0:00",
    "source": "Torch",
    "type": "MARGIN - RELEASE",
    "enterprise": true,
    "metadata": {
        "type": "Margin",
        "subtype": "Release"
    },
    "lines": [
        {
            "account": "23500 - Collateral Due to Counterparty",
            "journalAssetQuantity": {
                "asset": "USD",
                "quantity": 55219.78356
            },
            "lineType": "debit",
            "inventoryAssetQuantity": null
        },
        {
            "account": "12080 - Fireblocks",
            "journalAssetQuantity": {
                "asset": "USD",
                "quantity": 55219.78356
            },
            "lineType": "credit",
            "inventoryAssetQuantity": {
                "asset": "BTC",
                "quantity": 1.48000000
            }
        }
    ]
},
{
    "id": '18bedc69-5fdd-4296-8f38-758bf4c72488',
    "user_id": 'b877f0ec-c056-43e3-9b9f-b22e9bcdbaff',
    "datetime": "2/6/21 0:00",
    "source": "Torch",
    "type": "MARGIN - SETTLEMENT",
    "enterprise": true,
    "metadata": {
        "type": "Margin",
        "subtype": "Settlement"
    },
    "lines": [
        {
            "account": "23500 - Collateral Due to Counterparty",
            "journalAssetQuantity": {
                "asset": "USD",
                "quantity": 5000000
            },
            "lineType": "debit",
            "inventoryAssetQuantity": null
        },
        {
            "account": "10625 - Silvergate Lending LLC - SEN *4109",
            "journalAssetQuantity": {
                "asset": "USD",
                "quantity": 5000000
            },
            "lineType": "credit",
            "inventoryAssetQuantity": null
        }
    ]
},{
  "id": '0ebc9ded-6c14-49a6-b158-cc1a01134214',
  "user_id": 'aa753208-690b-4b91-a579-7688f8e476ca',
  "datetime": "1/6/21 0:00",
  "source": "Torch",
  "type": "LOAN - LENDER",
  "enterprise": true,
  "metadata": {
      "type": "Loan",
      "subtype": "Lender"
  },
  "lines": [
      {
          "account": "15001 - Institutional Loans",
          "journalAssetQuantity": {
              "asset": "USD",
              "quantity": 33774955.35
          },
          "lineType": "debit",
          "inventoryAssetQuantity": null
      },
      {
          "account": "12080 - Fireblocks",
          "journalAssetQuantity": {
              "asset": "USD",
              "quantity": 33774955.35
          },
          "lineType": "credit",
          "inventoryAssetQuantity": {
              "asset": "BTC",
              "quantity": 982.00000000
          }
      }
  ]
},
{
  "id": '15c87d2e-4b0b-4c4f-909c-6a80ac94db26',
  "user_id": 'aa753208-690b-4b91-a579-7688f8e476ca6',
  "datetime": "1/21/21 0:00",
  "source": "Torch",
  "type": "LOAN - LENDER",
  "enterprise": true,
  "metadata": {
      "type": "Loan",
      "subtype": "Lender"
  },
  "lines": [
      {
          "account": "12080 - Fireblocks",
          "journalAssetQuantity": {
              "asset": "USD",
              "quantity": 1717902.26
          },
          "lineType": "debit",
          "inventoryAssetQuantity": {
              "asset": "BCH",
              "quantity": 3906.00000000
          }
      },
      {
          "account": "15001 - Institutional Loans",
          "journalAssetQuantity": {
              "asset": "USD",
              "quantity": 1717902.26
          },
          "lineType": "credit",
          "inventoryAssetQuantity": null
      }
  ]
},
{
  "id": 'eaf41443-0ef3-40dd-89c2-3464dd569288',
  "user_id": '0efff795-4cf5-4fad-9655-a4589df4362d',
  "datetime": "1/21/21 0:00",
  "source": "Torch",
  "type": "LOAN - BORROWER",
  "enterprise": true,
  "metadata": {
      "type": "Loan",
      "subtype": "Borrower"
  },
  "lines": [
      {
          "account": "10620 - Silvergate INC - SEN *4191",
          "journalAssetQuantity": {
              "asset": "USD",
              "quantity": 1092000
          },
          "lineType": "debit",
          "inventoryAssetQuantity": null
      },
      {
          "account": "10620 - Silvergate INC - SEN *4191",
          "journalAssetQuantity": {
              "asset": "USD",
              "quantity": 10000000
          },
          "lineType": "debit",
          "inventoryAssetQuantity": null
      },
      {
          "account": "25000 - Institutional Borrows - USD",
          "journalAssetQuantity": {
              "asset": "USD",
              "quantity": 11092000
          },
          "lineType": "credit",
          "inventoryAssetQuantity": null
      }
  ]
},
{
  "id": 'a60fb556-2ea0-4eca-aa8a-763d6ca7aa98',
  "user_id": '0efff795-4cf5-4fad-9655-a4589df4362d',
  "datetime": "1/21/21 0:00",
  "type": "LOAN - BORROWER",
  "enterprise": true,
  "source": "Torch",
  "metadata": {
      "type": "Loan",
      "subtype": "Borrower"
  },
  "lines": [
      {
          "account": "25000 - Institutional Borrows - USD",
          "journalAssetQuantity": {
              "asset": "USD",
              "quantity": 7000000
          },
          "lineType": "debit",
          "inventoryAssetQuantity": null
      },
      {
          "account": "10625 - Silvergate Lending LLC - SEN *4109",
          "journalAssetQuantity": {
              "asset": "USD",
              "quantity": 7000000
          },
          "lineType": "credit",
          "inventoryAssetQuantity": null
      }
  ]
}
]
const journalEntries = []

const deriveUsdVolume = (transaction) => {
    return transaction.lines
        .filter(x => x.lineType === 'credit')
        .reduce((r,x) => {
            return r + x.journalAssetQuantity.quantity
        }, 0)
}
const getUsdVolumne = (transaction) => {
    const {prices} = transaction
    const price = prices ? prices[0]: undefined
    if(price) {
        return price?.quantity
    } else {
        return deriveUsdVolume(transaction)
    }
}

const EnterpriseTransactions = () => {
  let history = useHistory();
  const {tenant} = useContext(AppContext);
  const [fetchUrl] = useFetch();
  const [transactions, setTransactions] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchUrl("runCustomReport", {query: 'SELECT * FROM TRANSACTIONS'}).then((response) => {
      const allCustomerTransactions = response.data;
      setTransactions(allCustomerTransactions);
    }).catch((error) => {
      setError(error);
    })
  }, [])

  const selectTransaction = (transaction) => {
    let transactionId = transaction.id
    history.push(`transactions/:id=${transactionId}`)
  }

  const handleSearch = async (search) => {
    alert(search);
  }

  const handleFilters = () => {
    alert('Filters')
  }

  const handlePagination = () => {
    alert('clicked')
  }

  return (
    <PageWrapper>
      <StyledForeground />
      <div className={'header'}>
        <h1>Enterprise Transactions</h1>
        <TBSearch darkMode={true} handleSearch={handleSearch} />
      </div>
      <div className={'subheader'}>
        <StyledFilters>
          <Button className={'filter-button'} node={'button'} wave={'light'}>
            Filters
            <Icon left>filter_list</Icon>
          </Button>
        </StyledFilters>
        <ExportTransactionsButton enterprise={true} />
      </div>
      <div className={'content'}>
        <StyledTable>
          <TableHeader>
            <th className={'small'}>Date</th>
            <th className={'small'}>Book</th>
            <th className={'small'}>Source</th>
            <th className={'small'}>Type</th>
            <th>Counter Party ID</th>
            <th>Transaction ID</th>
            <th className={'small'}>USD Volume</th>
          </TableHeader>
          <div>
            {
              journalEntries2 && journalEntries2.map((transaction, index) => {
                const {external_id, prices} = transaction
                return (
                    <TransactionRow
                      enterprise={true}
                      handleClick={selectTransaction}
                      transaction={transaction}
                      key={external_id}
                      index={index}
                      price={getUsdVolumne(transaction)}
                    />
                  )
              })
            }
            {
              transactions && transactions.map((transaction, index) => {
                const {external_id, prices} = transaction
                const price = prices ? prices[0]: undefined
                if (index < 100) {
                  return (
                    <TransactionRow
                      enterprise={true}
                      handleClick={selectTransaction}
                      transaction={transaction}
                      key={external_id}
                      index={index}
                      price={price?.quantity}
                    />
                  )
                }
              })
            }
          </div>
        </StyledTable>
      </div>
      <Pagination
        label={'Transactions'}
        handleClick={handlePagination}
        page={1}
        pages={10}
        count={{start: 0, end: 1}}
        total={10}
        perPage={10}
      />
    </PageWrapper>
  )
}

export default EnterpriseTransactions;
